import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { dbApp } from "../../../firebase/config";

const ListadoPromociones = ({ promociones, getPromociones }) => {
  const [show, setShow] = useState(false);
  const [idPromocionDel, setIdPromocionDel] = useState("");

  const handleClose = () => {
    setShow(false);
    setIdPromocionDel("");
  };

  const handleShow = id => {
    setIdPromocionDel(id);
    setShow(true);
  };

  const handleConfirm = () => {
    console.log("Confirm", idPromocionDel);
    dbApp
      .collection("promociones")
      .doc(idPromocionDel)
      .delete()
      .then(() => {
        console.log("OK");
        setShow(false);
        setIdPromocionDel("");
        getPromociones();
      })
      .catch(() => {
        setShow(false);
        setIdPromocionDel("");
        console.log("Error.");
      });
  };

  return (
    <>
      <table className="table table-striped">
        <thead>
          <tr>
            <th scope="col texto-centrado">Nombre</th>
            <th scope="col d-flex justify-content-end">Opciones</th>
          </tr>
        </thead>
        <tbody>
          {promociones.map(promocion => (
            <tr key={promocion.id}>
              <td>{promocion.titulo}</td>
              <td className="d-flex justify-content-end">
                <i
                  className="fa fa-pencil-square-o text-primary fa-lg m-2 cursor-pointer"
                  aria-hidden="true"
                  onClick={() => console.log("Actualizar")}
                ></i>
                <i
                  className="fa fa-trash-o text-danger fa-lg m-2 cursor-pointer"
                  aria-hidden="true"
                  onClick={() => handleShow(promocion.id)}
                ></i>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar Promoción!</Modal.Title>
        </Modal.Header>
        <Modal.Body>¿Desea eliminar la promoción?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            <i className="fa fa-ban" aria-hidden="true"></i> Cancelar
          </Button>
          <Button variant="danger" onClick={() => handleConfirm()}>
            <i className="fa fa-trash" aria-hidden="true"></i> Eliminar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ListadoPromociones;
